module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Bold.a2b223c.eot";